import React from 'react';
import { Route, IndexRoute } from 'react-router';
import Loadable from 'react-loadable';

import ErrorPage from 'ggApp/shared/screens/ErrorPage';
import CircleLoader from 'ggApp/shared/components/CircleLoader';
import { withAuthGuard } from 'ggApp/modules/router/hocs';

const Loading = (): JSX.Element => <CircleLoader />;

const YourFeedbackWrap = Loadable({
    loader: () =>
        import(/* webpackChunkName: "YourFeedbackWrap" */ 'ggApp/shared/screens/YourFeedback/Wrap'),
    loading: Loading,
    delay: 300,
    timeout: 10000,
});

const YourFeedbackView = Loadable({
    loader: () =>
        import(/* webpackChunkName: "YourFeedbackView" */ 'ggApp/shared/screens/YourFeedback/View'),
    loading: Loading,
    delay: 300,
    timeout: 10000,
});

const GuardScreen = ({ children }: { children: React.ReactElement }): JSX.Element => (
    <React.Fragment>{children}</React.Fragment>
);

const YourFeedbackRoutes = (): JSX.Element => (
    <Route path="your-feedback" component={withAuthGuard(GuardScreen)}>
        <IndexRoute component={ErrorPage} />

        <Route component={YourFeedbackWrap}>
            <Route path=":pollSlug" component={YourFeedbackView} />
        </Route>
    </Route>
);

export default YourFeedbackRoutes;
